import { FC } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';
import { ExitToAppSvg } from './svgs';

export const IconExitToApp: FC<SvgIconProps> = (props) => {
  return <SvgIcon component={ExitToAppSvg} viewBox="0 0 24 24" {...props} />;
};
